import React from "react";

function PaymentInfo() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
      {/* USA Card */}
      <div className="bg-white rounded-xl shadow-md border border-sritaru-200 p-6">
        <div className="flex items-center space-x-2 mb-4">
          <span className="text-2xl">&#127482;&#127480;</span>
          <h3 className="text-lg font-bold text-sritaru-800">USA Payments</h3>
        </div>
        <div className="space-y-3 text-sm text-gray-700">
          <div className="bg-sritaru-50 rounded-lg p-3">
            <p className="font-semibold text-sritaru-700">Zelle</p>
            <p className="text-xs text-gray-500">Zelle ID</p>
            <p className="font-mono text-lg">sritaru</p>
            <p className="text-gray-500">Anirveda Peetham Foundation</p>
          </div>
          <div className="bg-sritaru-50 rounded-lg p-3">
            <p className="font-semibold text-sritaru-700">PayPal</p>
            <p>
              <a
                href="https://paypal.me/rayavaram"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sritaru-600 underline hover:text-sritaru-800"
              >
                paypal.me/rayavaram
              </a>
            </p>
            <p className="text-gray-500 text-xs">
              (Select &quot;Friends &amp; Family&quot; option)
            </p>
          </div>
        </div>
        <div className="mt-4 bg-earth-50 rounded-lg p-2 text-center">
          <p className="text-sm text-earth-600">
            Memo: <span className="font-bold text-earth-700">B+ SriTaru</span>
          </p>
        </div>
      </div>

      {/* India Card */}
      <div className="bg-white rounded-xl shadow-md border border-sritaru-200 p-6">
        <div className="flex items-center space-x-2 mb-4">
          <span className="text-2xl">&#127470;&#127475;</span>
          <h3 className="text-lg font-bold text-sritaru-800">
            India Payments
          </h3>
        </div>
        <div className="space-y-3 text-sm text-gray-700">
          <div className="bg-sritaru-50 rounded-lg p-3">
            <p className="font-semibold text-sritaru-700">G-Pay / UPI</p>
            <p className="font-mono text-lg">9701212222</p>
            <p className="text-gray-500">Nipuna Human Development Society</p>
          </div>
        </div>
        <div className="mt-4 bg-earth-50 rounded-lg p-2 text-center">
          <p className="text-sm text-earth-600">
            Memo: <span className="font-bold text-earth-700">B+ SriTaru</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default PaymentInfo;
